import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import SwiperCore, {Autoplay, EffectFade, Navigation, Pagination } from "swiper/core";
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { ActivatedRoute, ActivationEnd, Event, Router } from '@angular/router';
import { ApsServiceService } from '../aps-service.service';
import { HttpClient } from '@angular/common/http';


// install Swiper modules
SwiperCore.use([Autoplay,Navigation, Pagination,EffectFade]);

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit  {
notifydatas:any=false;
notifydata:any;

  constructor(private toastr: ToastrService, private activatedRoute: ActivatedRoute,private services:ApsServiceService,private router: Router,private http: HttpClient) {

    this.router.events
          .subscribe(
            (event: Event) => {
             //console.log(event)
            });
   }
  @ViewChild('containeritem') containeritem: ElementRef<HTMLElement>;

  ngOnInit(): void {

   

  //console.log("checking router")
  //  const section = this.container.nativeElement.querySelector(`#section3`)
  //       //console.log(section)

        // section?.scrollIntoView()
    // this.activatedRoute.queryParams.subscribe(param => {
    //   //console.log(param)
    //   if(param.contact){
    //     const section = this.container.nativeElement.querySelector(`#contactus`)
    //     section.scrollIntoView()
    //   }
    // })


    this.openlogins()

    $("button").click(function(){
      $("iframe").each(function(){
          $(this).attr("src", $(this).data("src"));
      });
  });


    this.viewNotify()

    this.services.envelop.subscribe(
      (name: string) => {
        this.goDown2();
      }
    );

  

  

    // this.toastr.success('Hello world!', 'Toastr fun!');
    $('.not-viewer').click(function(){
      //console.log("working")
      $('.not-items').fadeToggle()
      $('.not-viewer').fadeToggle();
      //console.log("click")
    
    }); 
    $('.not-close-viewer ').click(function(){
      //console.log("working")
      $('.notification').fadeToggle()
     
    
    }); 
    $(".sideicon").click(function(){
      $("#rightMenu").css("display", "block")
      $(".sideicon").css("display", "none")
      //console.log('click')
  
    });
    $(".close").click(function(){
      // $(".notify").css("display", "none")
      $("#rightMenu").css("display", "none")
      $(".sideicon").css("display", "flex")

  
    });
    

  }
  
openloginpages(){
  this.services.onFirstComponent();  

}
openregpage(){
  this.services.onFirstComponentButtonClick();   
}

  openlogins(){
    //console.log("navigation start");
    this.activatedRoute.queryParams.subscribe(params => {
      let productid = params['productid'];
      let reg = params['Login'];
      if(reg=="signup"){
        //console.log("this")
      this.services.onFirstComponentButtonClick();    
      }else if(reg=="login"){
        this.services.onFirstComponent();  
      }
    });
  }


  openbot(){
    $('.botdetails').fadeToggle()
    $("iframe").each(function(){
      $(this).attr("src", $(this).data("src"));
  });
  }
  

  goDown2() {
    //this.scroller.scrollToAnchor("targetGreen");
    document.getElementById("contactus").scrollIntoView();
  }

  viewNotify() {
    //this.scroller.scrollToAnchor("targetGreen");
    this.services.getnoify().subscribe((responce) => {
      if(responce.status){
        this.notifydatas=true
        this.notifydata=responce.datas
       
      }else{
        this.notifydatas=false
        $(".notify").css("display", "none");
      }

    })
  }
}
